module.exports = __webpack_public_path__ + "static/media/04.0f80cc7c.svg";